module.exports = __webpack_public_path__ + "img/farizon-draw.dd9139e4.jpg";